export default __webpack_public_path__ + "static/media/coach-bundle_gray@1x.26cbffe5.jpg";